<template>
  <div v-if="bstkImportConfig?.type">
    <RsBanner
      v-if="title"
      :is-title-message-stacked="true"
      :title="title"
      icon-img="/img/bstk/bstk-logo-sm.png"
      type="help-text-primary"
      size="custom"
      :custom-height="customHeight"
      :custom-icon-size="20"
      :message="message"
      class="py-2"
    />
    <RsBanner
      v-else
      icon-img="/img/bstk/bstk-logo-sm.png"
      type="help-text-primary"
      size="custom"
      :custom-height="customHeight"
      :custom-icon-size="20"
      :message="message"
    />
  </div>

  <div v-else-if="dataSource && (property?.importId || !property)">
    <RsBanner
      v-if="title"
      :is-title-message-stacked="true"
      :title="title"
      icon="fa-solid fa-hexagon-exclamation"
      type="help-text-primary"
      :message="message"
    />
    <RsBanner
      v-else
      icon="fa-solid fa-hexagon-exclamation"
      type="help-text-primary"
      size="custom"
      :custom-height="customHeight"
      :custom-icon-size="20"
      :message="message"
    />
  </div>
</template>
<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { TBSTKImportConfig } from '@/shared/helpers/building-stack';
import { mapModuleGetters } from '@/shared/vuex-toolkit';
import { properties } from '@/store/typed/typed-modules';

export default defineComponent({
  name: 'RsImporterFieldBanner',
  props: {
    title: {
      type: String,
      default: null,
    },
    dataSource: {
      type: String,
      default: null,
    },
    customMessage: {
      type: String,
      default: null,
    },
    customHeight: {
      type: Number,
      default: 35,
    },
    bstkImportConfig: {
      type: Object as PropType<TBSTKImportConfig | null>,
      default: () => null,
    },
  },
  computed: {
    ...mapModuleGetters(properties, { property: 'single' }),
    message(): string {
      if (this.bstkImportConfig?.field) {
        return `Some fields below are managed by your <b style="font-weight:600;">Building Stack</b> integration. Changes made will be temporary.`;
      }

      if (this.customMessage) {
        return this.customMessage.replace(this.dataSource, `<b style="font-weight:600;">${this.dataSource}</b>`);
      }
      return this.dataSource
        ? `Some fields below are managed by <b style="font-weight:600;">${this.dataSource}</b>. Changes made will be temporary.`
        : '';
    },
    paddingY(): string {
      return this.title ? '2' : '1';
    },
  },
});
</script>
